<template>
  <div id="quote-tool-v2" class="v2-container">
    <div class="quote-tool-wrapper-v2">
      <div v-if="!hideTitle" class="mb-4 pt-4">
        <h2 class="text-center">{{ config.title }}</h2>
        <h5 class="text-center px-5">
          {{ config.subtitle }}
        </h5>
      </div>
      
      <v-stepper
        id="quote-tool-stepper-v2"
        :vertical="useVerticalGroupStepper"
        :key="useVerticalGroupStepper"
        v-model="currentStep"
        flat
      >
        <v-stepper-header v-if="!hideSteps" class="border-none">
          <template v-for="(group, index) in stepGroups">
            <v-stepper-step
              :key="'group-' + index"
              :step="group.steps[0].step"
              :complete="true"
              :editable="currentStep >= group.last_step_index"
              :color="currentStep > group.last_step_index ? 'success' : (currentStep >= group.step && currentStep <= group.last_step_index ? 'black' : 'grey')"
              :edit-icon="group.icon || 'mdi-check'"
              :complete-icon="group.icon || 'mdi-check'"
            >
            
              <div class="black--text" :class="{'primary--text': currentStep > group.last_step_index, 'grey--text': currentStep < group.steps[0].step}">{{ group.title }}</div>
              <template v-if="group.subtitle">
                <small v-html="group.subtitle" />
              </template>
            </v-stepper-step>
          </template>         
          <v-progress-linear
            :active="loading > 0"
            :indeterminate="loading > 0"
            color="accent"
            id="loading"
          ></v-progress-linear>
        </v-stepper-header>
        <v-divider/>
        <v-stepper-items>
          <template v-for="(publicStep, id) in publicSteps">
            <v-stepper-content :key="id" :step="id + 1" :class="{'py-0': currentStep !== (id + 1)}">
              <h3 class="py-3 py-md-0 stepper-title text-start primary--text text-h5 font-weight-bold" :class="{'d-none': publicStep.hiddenTitle}" v-if="publicStep.title != 'n/a' || publicStep.hiddenTitle">{{  publicStep.title }}</h3>
              <p class="mb-5 stepper-subtitle" v-if="!publicStep.hiddenSubtitle">{{ publicStep.subheader }}</p>
              <component
                v-if="currentStep > id"
                :is="publicStep.component"
                :stepKey="id + 1"
                :nextStep="nextStep"
                :previousStep="id !== 0 ? previousStep : undefined"
                :stepObject="publicStep"
              ></component>
            </v-stepper-content>
          </template>
        </v-stepper-items>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import LocationStep from "./steps-v2/Location";
import CustomerStep from "./steps-v2/Customer";
import ServiceStep from "./steps-v2/Service";
import DateStep from "./steps-v2/Date";
import FinishStep from "./steps-v2/Finish";
import Review from "./steps-v2/Review";
import ProjectTypeStep from "./steps-v2/ProjectType";
import MaterialTypeStep from "./steps-v2/MaterialType";
import ContainerSizeStep from "./steps-v2/ContainerSize";
import { createNamespacedHelpers } from "vuex";
import QuoteSection from "./utils/QuoteSection.vue";
import { mapFields } from "vuex-map-fields";
const {
  mapState,
  mapGetters,
  mapActions,
  mapMutations
} = createNamespacedHelpers("quotes");

export default {
  name: "QuoteToolV2",
  components: {
    QuoteSection,
    LocationStep,
    CustomerStep,
    DateStep,
    FinishStep,
    Review,
    ServiceStep,
    ProjectTypeStep,
    MaterialTypeStep,
    ContainerSizeStep,
    InitialCustomerStep: CustomerStep
  },
  data: () => ({
    loadingCustomer: false,
    stepGroups: [
      {
        title: "Service Details",
        step: 1,
        last_step_index: 2,
        completed: false,
        icon: 'mdi-account',
        steps: [
          { title: "Step 1", step: 1 },
          { title: "Step 2", step: '1.2' },
          { title: "Step 3", step: '1.3' },
        ]
      },
      {
        title: "Project Details",
        step: 3,
        last_step_index: 5,
        completed: false,
        icon: 'mdi-hammer-screwdriver',
        steps: [
          { title: "Step 4", step: 3 },
          { title: "Step 5", step: '2.2' },
          { title: "Step 6", step: '2.3' },
        ]
      },
      {
        title: "Review",
        step: 6,
        last_step_index: 7,
        completed: false,
        icon: 'mdi-cart',
        steps: [
          { title: "Step 7", step: 6 },
          { title: "Step 8", step: '3.2' },
          { title: "Step 9", step: '3.3' },
        ]
      },
    ],
    currentUrl: window.location.href
  }),
  props: ["config"],
  computed: {
    ...mapFields("quotes", ["completedSteps"]),
    ...mapGetters([
      "userAccess",
      "publicSteps",
      "isInitialized",
      "customerData"
    ]),
    ...mapState(["loading", "messages", "quote"]),
    ...mapState({
      cStep: state => state.currentStep
    }),
    currentStep: {
      get() {
        return this.cStep;
      },
      set(value) {
        this.SET_STEP(value);
      }
    },
    useVerticalStepper() {
      if(this.config?.useHorizontalStepper){
        return false
      }
      return true;
    },
    useVerticalGroupStepper() {
      return ["xs", "sm"].includes(this.$vuetify.breakpoint.name);
    },
    currentStepObject() {
      return this.publicSteps[this.currentStep - 1];
    },
    hideTitle(){
      if(this.config?.hideTitle){
        return true
      }
      return false;
    },
    hideSteps(){
      if(this.config?.hideSteps || this.currentStep === 8){
        return true
      }
      return false;
    }
  },
  methods: {
    ...mapMutations(["SET_STEP"]),
    ...mapActions(["updateBaseData", "createQuote", "processQuotePayment"]),
    updateQid() {
      const qid =
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      window.localStorage.setItem("ro360-qid", qid);
    },
    scrollToTop(isOnPreviousStep=false) {
      const container = document.getElementById('quote-tool-v2');
      if(container){
        const headerHeight = this.currentUrl.includes("nextdaystaging.com/order") ? 80 : 0
        const scrolledY = window.scrollY;

        if(scrolledY){
          if(this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs){
            container.scrollIntoView({ block: 'start', behavior: 'smooth' });
            window.scroll(0, headerHeight);
          }
          else if(this.currentStep >= 6 || (isOnPreviousStep && this.currentStep === 5)){
            // we want to scroll near where the wizard starts on the page
            window.scroll(0, headerHeight + 100);
          }
        }
      }
    },
    nextStep() {
      this.currentStep++;
      this.scrollToTop(false)
    },
    previousStep() {
      this.currentStep--;
      this.scrollToTop(true)
    }
  },
  mounted() {
    // Load base data
    this.$store.dispatch("quotes/updateBaseData");

    if (!window.localStorage.getItem("ro360-qid")) {
      // Generate random ID
      this.updateQid();
    }

    this.$store.dispatch("quotes/logQuote", {
      action: "initialized",
      qid: window.localStorage.getItem("ro360-qid")
    });
  },
  watch: {
    config: {
      handler() {
        this.$store.commit("quotes/SET_CONFIG", this.config);
      },
      deep: true
    },
    currentStep(value) {
      // Check if there was a previous step, and if so, add it's component name to completedSteps
      if (value > 1) {
        const component = this.publicSteps[value - 2].component;

        if (!this.completedSteps.includes(component)) {
          this.completedSteps = [...this.completedSteps, component];
        }

        this.$store.dispatch("quotes/logAnalyticsEvent");
      }
      this.$store.dispatch("quotes/logQuote", {
        action: "step_change",
        data: { step: value, form: this.customerData },
        qid: window.localStorage.getItem("ro360-qid")
      });

      setTimeout(() => {
        if (this.currentStepObject.component === "ServiceStep") {
          if (!this.quote.created) {
            this.createQuote(true).then(() => {
              // Log analytics event for "soft lead".
              this.$store.dispatch("quotes/logAnalyticsEvent", {
                event: "soft_lead",
                params: {
                  event_label: "Soft Lead Created"
                }
              });
            });
          }
        }
        if (this.publicSteps.length && value === this.publicSteps.length) {
          if (!this.quote.created || this.quote.service.id) {
            this.createQuote(this.quote.purchaseService).then(() => {
              // Update QID
              this.updateQid();

              // Log analytics event for "quote_created".
              this.$store.dispatch("quotes/logAnalyticsEvent", {
                event: "quote_created",
                params: {
                  event_label: "Quote Created"
                }
              });

              if (this.quote.purchaseService) {
                this.processQuotePayment().then(() => {
                  // Log analytics event for "quote_paid".
                  this.$store.dispatch("quotes/logAnalyticsEvent", {
                    event: "quote_paid",
                    params: {
                      event_label: "Quote Paid"
                    }
                  });
                });
              }
            });
          } else if (this.quote.purchaseService) {
            this.processQuotePayment().then(() => {
              // Log analytics event for "quote_paid".
              this.$store.dispatch("quotes/logAnalyticsEvent", {
                event: "quote_paid",
                params: {
                  event_label: "Quote Paid"
                }
              });
            });
          }
        }
      }, 500);
    }
  }
};
</script>
<style>
.quote-tool-step-content {
  padding: 5px;
}
.quote-tool-step-content .v-input--selection-controls{
  margin-top:0 !important
}
.v2-container {
  max-width: 100%;
  min-height: 100vh;
  background-color: white;
}

.quote-tool-wrapper-v2 {
  margin: auto;
  background-color: #fff;
  min-height: 100vh;
  max-width: 800px;
  @media screen and (max-width: 600px) {
    margin: 0;
    max-width: 100%;
  }
}

.v-stepper__header{
  box-shadow: none !important;
}

.v-stepper--vertical .v-stepper__header{
  height: auto;
  display: block;
}
.v-stepper--vertical .v-stepper__step{
  padding:10px !important;
}
.v-application--is-ltr .v-stepper--vertical .v-stepper__content{
  margin:0 !important;
}

.stepper-title{
  margin: 10px 0;
  padding-left: 5px;
  @media screen and (max-width: 600px) {
    margin: 0;
  }
}

.stepper-subtitle{
  font-size: 0.9rem;
  font-family: "Roboto", sans-serif !important;
  padding-left: 5px;
}
</style>
